<template>
  <div class="container-xxl">
    <template v-if="!auth.estaLogado()">
      <div class="col-md-10 col-lg-8 col-xl-6 col-xxl-4 offset-md-1 offset-lg-2 offset-xl-3 offset-xxl-4 py-3">
        <Titulo :sombra="false" titulo='Recuperação de senha' icon="" posicao="center" />
        <fieldset>
          <div class="alert alert-info text-center">
            Digite o código enviado para o email <strong>{{ user.verifica_email }}</strong>
          </div>
          <form id="login" @submit.prevent="confirma_cod_email()">
            <InputText classDiv="col-md-12" placeholder="" nome="cod_verify" tipo="text" label="Código de verificação *"
              tamanho="sm" :required="true" v-model="user.cod_verify" />

            <div class="d-grid gap-2 mx-auto">
              <button type="submit" class="btn btn-info text-white btn-lg">
                Confirmar código de verificação
                <Spinner :visivel="false" id="load" />
              </button>
            </div>
          </form>
          <div class="row">
            <div class="col-6 col-md-4 d-grid gap-2 mx-auto">
              <a href="/#formulario" class="btn btn-light mt-2 btn-block">Cadastre-se</a>
            </div>
            <div class="col-6 col-md-4 d-grid gap-2 mx-auto">
              <router-link to="/login" class="btn btn-light mt-2 btn-block">Login</router-link>
            </div>
            <div class="col-6 col-md-4 d-grid gap-2 mx-auto">
              <router-link to="/recuperar_senha" class="btn btn-light mt-2 btn-block">Recuperar outro
                email</router-link>
            </div>
          </div>
        </fieldset>
      </div>
    </template>
    <template v-else>
      <div class="col-md-10 offset-md-1 py-3 mt-5">
        <boas-vindas :nome="auth.nomeUser" />
      </div>
    </template>
  </div>
</template>

<script>
import { bloqueia_campos, mensagem_request } from '@/assets/js/functions';
import InputText from '@/components/form/InputText.vue';
import Spinner from '@/components/Spinner.vue';
import Titulo from '@/components/Titulo.vue';
import { toastr } from '@/plugins/toast';
import { api } from '@/services/api';
import { AuthStore } from '@/stores/Auth';

export default {
  name: 'ConfirmarCodigo',
  data() {
    return {
      user: {
        verifica_email: localStorage.getItem('email')
      },
      auth: AuthStore(),
      disable: false,
      verifica_envio: (localStorage.getItem('verifica_envio') ? localStorage.getItem('verifica_envio') : false)
    }
  },
  components: {
    InputText,
    Spinner,
    Titulo,
  },
  methods: {
    async confirma_cod_email() {
      bloqueia_campos()
      try {
        const data = await api.post('login/cod_verify', this.user)

        mensagem_request(data)
        if (data.status == 200) {
          localStorage.setItem('codigo',this.user.cod_verify)
          this.$router.push('alterar_senha')
        }

      } catch (error) {
        toastr.erro("Erro ao fazer o login.");
      }
      bloqueia_campos(false)
    },
  },
  mounted() {
    if(this.user.verifica_email == null){
      this.$router.push('recuperar_senha')
    }
    
    if(this.auth.estaLogado()){
      this.$router.push('login')
    }
  },
}
</script>

<style scoped></style>